<at-members-filter class="header" [(filter)]="filterValue">
  <h3 class="heading-lg">Members availability</h3>
</at-members-filter>
<form [formGroup]="rangeForm()">
  @let availabilityClassFn = getDateClass();
  @if (availabilityClassFn) {
    <at-calendar-range-picker
      [(selected)]="selectedDates"
      [startAt]="startDate()"
      [minDate]="startDate()"
      [dateFilter]="dateFilter()"
      [dateClass]="availabilityClassFn"></at-calendar-range-picker>
  } @else {
    <at-calendar-range-picker
      [(selected)]="selectedDates"
      [startAt]="startDate()"
      [minDate]="startDate()"
      [dateFilter]="dateFilter()"></at-calendar-range-picker>
  }
</form>
<div class="members breakout">
  @if (filteredResponses().FullyAvailable.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().FullyAvailable,
            title: 'Available all days',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (filteredResponses().PartiallyAvailable.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().PartiallyAvailable,
            title: 'Available some days',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (filteredResponses().Unavailable.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().Unavailable,
            title: 'Unavailable',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (filteredResponses().NotReplied.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().NotReplied,
            title: 'No reply',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (isFilterResultEmpty()) {
    <div class="empty-content">
      <p class="body-copy-md">No results found</p>
      <button class="button primary" (click)="clearFilter()" type="button">
        Clear filter
      </button>
    </div>
  } @else if (isFilterResultEmpty() && !filterValue()) {
    <div class="empty-content">
      <p class="body-copy-md">
        No members have submitted their availability yet.
      </p>
    </div>
  }
</div>

<ng-template #membersList let-responses>
  <details class="section-details" [open]="responses.isOpen">
    <summary class="section-summary">
      <div class="section-details-header">
        <h3 class="heading-md">{{ responses.title }}</h3>
        <p class="body-copy-sm">{{ responses.members.length }} members</p>
      </div>
    </summary>
    <ul class="member-list">
      @for (member of responses.members; track member.userId) {
        <li class="member-row">
          <at-display-name showAvatar size="md" [user]="member" [showOwnerBadge]="member.userId | isTripOwner"></at-display-name>
          @if (member.message) {
            <dl class="member-message">
              <dt class="all-caps violet-darker">Message</dt>
              <dd class="body-copy-sm">{{ member.message }}</dd>
            </dl>
          }
          @if (member.availableDays > 0) {
            <div
              class="mis-auto member-availability"
              [style.--avail-percent.%]="member.percentage">
              <p>{{ member.availableDays }}/{{ member.totalDays }}</p>
              <div class="member-availability-indicator"></div>
            </div>
          }
        </li>
      }
    </ul>
  </details>
</ng-template>
